// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/content_block_inclusions/:id" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlockInclusionsId } from "./constants";
import type { EngagementContentBlockInclusionsResult, EngagementContentBlockInclusionsParams } from "./types";
import { isEngagementContentBlockInclusionsResult } from "./validators";

export const getEngagementContentBlockInclusionsId = reactQueryFetcherAdapter(
  engagementContentBlockInclusionsId,
  (
    signal: AbortSignal,
    {
      contentBlockId,
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementContentBlockInclusionsParams
  ): Promise<EngagementContentBlockInclusionsResult> => {
    return fetch(
      `/engagement/content_block_inclusions/${contentBlockId}`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementContentBlockInclusionsResult
);
